import { TextKey } from '@mews-commander/enums';
import { PaymentPlanDetailsLink } from '../../../../common/PaymentPlanDetailsLink';
import { usePaymentDetailsSidebarContext } from '../../context/PaymentDetailsSidebarContext';
import { PaymentDetailsSidebarRow } from '../PaymentDetailsSidebarRow';

export const PaymentPlanDetails = () => {
    const { accountId, paymentPlanId, paymentPlanName } = usePaymentDetailsSidebarContext();

    if (!paymentPlanId || !paymentPlanName || !accountId) {
        return null;
    }

    return (
        <PaymentDetailsSidebarRow labelTextKey={TextKey.PaymentPlan}>
            <PaymentPlanDetailsLink linkContent={paymentPlanName} paymentPlanId={paymentPlanId} accountId={accountId} />
        </PaymentDetailsSidebarRow>
    );
};
